export default __webpack_public_path__ + "static/media/demo1.3e9c56ae.mp4";